import {RGB} from '@wandb/weave/common/util/colors';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import ColorPicker from '../../../../ColorPicker';

export type OverlaysTableRowProps = {
  title: string;
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  color?: RGB;
  setColor?: (color: string) => void;
  'data-test'?: string;
};

export const OverlaysTableRow = ({
  title,
  isVisible,
  setIsVisible,
  color,
  setColor,
  'data-test': dataTest,
}: OverlaysTableRowProps) => {
  const backgroundColor = color
    ? `rgb(${color[0]}, ${color[1]}, ${color[2]})`
    : null;
  return (
    <div
      className="mt-16 flex h-32 items-center justify-between first:mt-0"
      data-test={dataTest}>
      <div className="flex items-center">
        <Button
          data-test={`visibility-toggle-${title}`}
          variant="ghost"
          icon={isVisible ? 'visible' : 'not-visible'}
          onClick={() => setIsVisible(!isVisible)}
        />
        <div className="ml-4" data-test="overlay-table-row-title">
          {title}
        </div>
      </div>
      {backgroundColor && (
        <ColorPicker
          activeColor={backgroundColor}
          setColor={setColor}
          readOnly={setColor == null}
          trigger="button"
          invertColorsInDarkMode={false}
        />
      )}
    </div>
  );
};
